export default __webpack_public_path__ + "static/media/empty_box.b8dc8607.png";